import styled from 'styled-components';
import { rgba } from 'polished';
import { cEA135E } from '#/colors';

export const Error = styled.div`
  display: grid;
  flex-grow: 1;
  place-items: center;
  color: ${rgba(cEA135E, 0.7)};
`;
